import audio from "../../assets/img/audio.png"
export const getCover = (cover)=>{
    var viewCover=""
    if (cover && cover.type) {
        
        if (cover.type.includes('image')){
            viewCover=cover.url.small
        }
        if (cover.type.includes('video')){
            viewCover=cover.url.thumbnail
        }
        if (cover.type.includes('audio')){
            viewCover=audio
        }
    }
    return viewCover

}